import React, { FC, useCallback, useEffect, useRef, useState } from 'react';
import {
  clearAllBodyScrollLocks,
  disableBodyScroll,
  enableBodyScroll,
} from 'body-scroll-lock';
import ReactDOM from 'react-dom';

// Components
import Icon from '../Icon';

interface Props {
  show: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

const Modal: FC<Props> = ({ show, onClose, children }) => {
  const ref = useRef<HTMLDivElement>(null);
  const [isMounted, setIsMounted] = useState(false);

  useEffect(() => {
    setIsMounted(show);
  }, [show]);

  const handleKey = useCallback(
    (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        return onClose();
      }
    },
    [onClose]
  );

  useEffect(() => {
    if (ref.current) {
      if (show) {
        disableBodyScroll(ref.current);
        window.addEventListener('keydown', handleKey);
      } else {
        enableBodyScroll(ref.current);
      }
    }
    return () => {
      window.removeEventListener('keydown', handleKey);
      clearAllBodyScrollLocks();
    };
  }, [show, handleKey]);

  const modalContent = show ? (
    <div className="modal-overlay" ref={ref}>
      <div>
        <div
          className="modal-content"
          style={{
            opacity: isMounted ? 1 : 0,
            transform: isMounted ? 'scale(1)' : 'scale(0.95)',
            transition: 'opacity 0.2s, transform 0.2s',
          }}
        >
          <button className="modal-content__close" onClick={onClose}>
            <Icon type="close" className="aea-form-icon aea-form-icon--md" />
          </button>
          <div>{children}</div>
        </div>
      </div>
    </div>
  ) : null;

  return ReactDOM.createPortal(
    modalContent,
    document.getElementById('modal-root')!
  );
};

export default Modal;
